<template>
  <article class="panel status-panel">
    <div class="panel-heading compact"><div><span class="panel-label">设备状态</span><h3>运行概览</h3></div></div>
    <div class="metric-list">
      <div class="metric-row"><span><i class="metric-icon signal"></i>Wi-Fi 信号</span><strong>{{ telemetry.rssi ? telemetry.rssi + ' dBm' : '--' }}</strong></div>
      <div class="signal-track"><div :style="{ width: signalPercent + '%' }"></div></div>
      <div class="metric-row"><span><i class="metric-icon uptime"></i>运行时间</span><strong>{{ formattedUptime }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon memory"></i>可用内存</span><strong>{{ formattedHeap }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon network"></i>摄像头状态</span><strong>{{ monitorActive ? `监控中 ${remainingSeconds}s` : '已关闭' }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon signal"></i>相机驱动</span><strong>{{ cameraStatusText }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon uptime"></i>视频发布</span><strong>{{ videoStatusText }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon memory"></i>最近帧大小</span><strong>{{ lastFrameBytes ? `${(lastFrameBytes / 1024).toFixed(1)} KB` : '--' }}</strong></div>
      <div class="metric-row"><span><i class="metric-icon network"></i>已接收画面</span><strong>{{ framesReceived }} 帧</strong></div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'DeviceStatus',
  props: {
    telemetry: { type: Object, required: true },
    monitorActive: Boolean,
    remainingSeconds: { type: Number, default: 0 },
    cameraStatus: { type: String, default: 'sleeping' },
    videoStatus: { type: String, default: 'idle' },
    lastFrameBytes: { type: Number, default: 0 },
    framesReceived: { type: Number, default: 0 }
  },
  computed: {
    signalPercent () {
      if (!this.telemetry.rssi) return 0
      return Math.max(5, Math.min(100, (Number(this.telemetry.rssi) + 100) * 2))
    },
    formattedUptime () {
      const seconds = Number(this.telemetry.uptime)
      if (!seconds) return '--'
      const days = Math.floor(seconds / 86400)
      const hours = Math.floor((seconds % 86400) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      return days ? `${days}天 ${hours}小时` : `${hours}小时 ${minutes}分`
    },
    formattedHeap () {
      const bytes = Number(this.telemetry.heap)
      return bytes ? `${(bytes / 1024).toFixed(1)} KB` : '--'
    },
    cameraStatusText () {
      return { sleeping: '休眠', starting: '启动中', ready: '已就绪', error: '初始化失败' }[this.cameraStatus] || this.cameraStatus
    },
    videoStatusText () {
      return { idle: '未发布', streaming: '正在发布', publish_failed: '发布失败' }[this.videoStatus] || this.videoStatus
    }
  }
}
</script>
